module.exports = __webpack_public_path__ + "static/media/logo_dark.008d2412.png";